module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("100")]), _vm._v(" "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("BUTTERCREAM "), _c('i', [_vm._v("Flowers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("Valeri Valeriano & Christina Ong")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("THE COMPLETE STEP-BY-STEP GUIDE TO PIPING FLOWERS IN BUTTERCREAM ICING")]), _vm._v(" "), _c('p', {
    staticClass: "web"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.stitchcraftcreate.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/logo.gif"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb7c5694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 60
// module chunks = 0